export default {
	name: "sequence-delivery-orders-for-delivery",
	data() {
		return {
			orders: [],
			expectedDateOfDelivery: null,
			loading: false,
			showSuccessMessage: false,
			successMessage: null,
			showErrorMessage: false,
			errorMessage: null,
			initialiseExpectedDate: true,
			orderItemsModalId: "orderItemsModal",
			selectedOrder:{
				orderId: null,
				totalAmount: 0,
			},
			sequenceNumberDuplicationErrorMessage: null
		};
	},
	methods: {
		getOrders(){
			this.orders = localStorageCacheHelper.getSelectedDeliveryOrdersForScheduling();
			if(this.orders === null || this.orders.length === 0){
				this.$router.go(-1);
			}
			else {
				var orderIds = this.orders.map(order => order.orderId);
				let request = {
					orderIds: orderIds
				};
				this.loading = true;
				
				locationService.sequenceOrdersBasedOnLocation(request).then(
					successfulResponse => {
						var orderSequences = successfulResponse.data.result;
						for (var i = 0; i < this.orders.length; i++) {
							for(var j = 0; j < orderSequences.length; j++){
								if(this.orders[i].orderId === orderSequences[j].orderId){
									this.orders[i].sequenceNumber = orderSequences[j].sequenceNumber;
									break;
								}
							}
						}
						this.orders.sort((a, b) => a.sequenceNumber - b.sequenceNumber);
						this.loading = false;
					},
					errorResponse => {
						this.loading = false;
						apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
					}
				);
			}
		},
		onBackClick(){
			this.$router.go(-1);	
		},
		onSequenceInput(order){
			this.sequenceNumberDuplicationErrorMessage = null;
			this.loading = true;
			if(order.sequenceNumber === null || order.sequenceNumber === undefined || order.sequenceNumber === ""){
				order.sequenceNumber = 1;
			}
			if(order.sequenceNumber < 1){
				order.sequenceNumber = 1;
			}
			var withUniqueSequenceNumbers = [];
			var duplicateSequenceNumbers = this.orders.filter(o => {
				if(withUniqueSequenceNumbers.find(wo => wo.sequenceNumber === o.sequenceNumber)){
					return true;
				}
				withUniqueSequenceNumbers.push(o);
				return false;
			})
			if(duplicateSequenceNumbers.length > 0){
				this.sequenceNumberDuplicationErrorMessage = "Sequence numbers duplicated for orders: " + duplicateSequenceNumbers.map(orderItem => orderItem.orderId).join(", ");
			}
			this.orders.sort((a, b) => a.sequenceNumber - b.sequenceNumber);
			var self = this;
			setTimeout(() => {
				self.loading = false;
			}, 500);

		},
		saveSequence(){
			// this.loading = true;
			// var orderDeliveryScheduleSequenceNumbers = [];
			// for(var i = 0; i < this.orders.length; i++){
			// 	orderDeliveryScheduleSequenceNumbers.push({
			// 		orderDeliveryScheduleId: this.orders[i].orderDeliveryScheduleId,
			// 		sequenceNumber: this.orders[i].sequenceNumber
			// 	});
			// }
			// let request = {
			// 	orderDeliveryScheduleSequenceNumbers: orderDeliveryScheduleSequenceNumbers,
			// 	expectedDateOfDelivery: this.expectedDateOfDelivery,
			// };
			// orderService.updateSequenceNumberForOrderDeliverySchedules(request).then(
			// 	successResponse => {
			// 		let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
			// 		if(isSuccess){
			// 			this.showSuccessMessage = true;
			// 			this.successMessage = "Sequence saved successfully";
			// 		}
			// 		this.loading = false;
			// 	},
			// 	errorResponse => {
			// 		console.log("error", errorResponse);
			// 		this.loading = false;
			// 		apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
			// 	}
			// );
			localStorageCacheHelper.cacheSelectedDeliveryOrdersForScheduling(this.orders, true);
			this.$router.push("/orders/delivery/scheduleDeliveryOrdersForDelivery");
		},
		onSuccessModalOkClick(){
			this.showSuccessMessage = false;
			this.$router.go(-1);
		},
		onOrderItemsModalClose(){
			$("#" + this.orderItemsModalId).modal("hide");
		},
		setBreadcrumbs() {
			var pageTitle = "Sequence Deliveries for Selected Orders";
			storeState.setPageTitleAction(pageTitle);
			breadcrumbsStoreState.updateBreadcrumbs(this.$route, pageTitle);
		}
	},
	mounted: function () {
		this.setBreadcrumbs();
		this.getOrders();
		var self = this;
		setTimeout(function () {
			self.expectedDateOfDelivery = new Date();
		}, 500);
	}
};